import {Component, OnInit, ViewChild} from '@angular/core';
import {BrandsService} from '../../services/brands/brands.service';
import {Router} from '@angular/router';
import {ApiService} from '../../services/api/api.service';
import {BaseComponent} from '../base/base.component';
import {UsersService} from '../../services/users/users.service';
import {AppSettings} from '../../app.settings';
import {WallitService} from '../../services/wallit/wallit.service';
import {IonRouterOutlet, NavController} from '@ionic/angular';

@Component({
  selector: 'app-header-home',
  templateUrl: './header-home.component.html',
  styleUrls: ['./header-home.component.scss'],
})
export class HeaderHomeComponent extends BaseComponent implements OnInit {

  protected releaseVersion;
  protected wallit;
  protected PRODUCTS_ONLY = this.brandsService.getUIConfig().productsOnly;
  protected showShoppingCart = this.brandsService.getUIConfig().shoppingCart;

  @ViewChild(IonRouterOutlet, { static: true }) routerOutlet: IonRouterOutlet;

  constructor(
      protected brandsService: BrandsService,
      private router: Router,
      apiService: ApiService,
      private usersService: UsersService,
      private wallitService: WallitService,
      private navCtrl: NavController
  ) {
    super(apiService);
  }

  ngOnInit() {
    this.releaseVersion = AppSettings.getReleaseVersion();
     this.wallitService.monitorWallitChanged(wallit => {
      this.wallit = Object.assign(wallit, {});
     });
  }

  loginClicked() {
    this.router.navigate([ '/SignIn' ]);
  }

  joinClicked() {
    this.router.navigate([ '/signup-username' ]);
  }

  async menuClicked() {
    // this.navCtrl.navigateForward('/WallitActions', { animationDirection: 'back' });
    // this.router.navigate([ '/WallitActions' ]);  }
    await this.navCtrl.navigateForward('/WallitActions');
  }

  balanceClicked() {
    this.router.navigate(['tabs/tab-accounts'], { replaceUrl: true });
  }

  async shoppingCartClicked() {
    this.router.navigate([ '/shopping-cart' ]);
  }

}
